/** Separate staff tools. Existing task/HR permissions still apply within each tool. */
export const STAFF_MODULE_CATALOG = [
  { key: 'operations', label: 'Operations', description: 'Open the Operations workboard, team capacity and setup.' },
  { key: 'hrHours', label: 'Hours worked', description: 'Enter their own hours. HR managers can also review team hours.' },
] as const
export type StaffModuleKey = typeof STAFF_MODULE_CATALOG[number]['key']
export type StaffModules = Record<StaffModuleKey, boolean>
export const STAFF_MODULE_KEYS = STAFF_MODULE_CATALOG.map(m => m.key)
const object = (v: unknown): Record<string, unknown> => v && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : {}
/** Only explicit boolean opt-ins on active staff memberships; a recorded deny wins. */
export function effectiveStaffModules(memberships: readonly { area: string; status: string; settings: unknown }[]): StaffModules {
  const active = memberships.filter(m => m.area === 'admin' && m.status === 'active').map(m => object(object(m.settings).staff_modules))
  return Object.fromEntries(STAFF_MODULE_KEYS.map(key => {
    const explicit = active.filter(m => Object.hasOwn(m, key)).map(m => m[key])
    return [key, explicit.length > 0 && explicit.every(value => value === true)]
  })) as StaffModules
}
declare module './api' { interface Me { staffModules?: StaffModules } }
